import translateLuggageCount from '@/utils/translateLuggageCount';

export default class LuggageCounter {
  luggage20InchCount = 0;
  luggage25InchCount = 0;
  luggage27InchCount = 0;
  luggage29InchCount = 0;

  get totalLuggageCount() {
    return (
      this.luggage20InchCount +
      this.luggage25InchCount +
      this.luggage27InchCount +
      this.luggage29InchCount
    );
  }

  get formatLuggageCount() {
    return translateLuggageCount({
      luggage20InchCount: this.luggage20InchCount,
      luggage25InchCount: this.luggage25InchCount,
      luggage27InchCount: this.luggage27InchCount,
      luggage29InchCount: this.luggage29InchCount,
    });
  }

  get isEmpty() {
    return this.totalLuggageCount === 0;
  }

  constructor({
    luggage20InchCount = 0,
    luggage25InchCount = 0,
    luggage27InchCount = 0,
    luggage29InchCount = 0,
  } = {}) {
    this.luggage20InchCount = luggage20InchCount;
    this.luggage25InchCount = luggage25InchCount;
    this.luggage27InchCount = luggage27InchCount;
    this.luggage29InchCount = luggage29InchCount;
  }

  clone() {
    return new LuggageCounter({
      luggage20InchCount: this.luggage20InchCount,
      luggage25InchCount: this.luggage25InchCount,
      luggage27InchCount: this.luggage27InchCount,
      luggage29InchCount: this.luggage29InchCount,
    });
  }
}
